/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnswererLineProfile
 */
export interface AnswererLineProfile {
    /**
     * 
     * @type {string}
     * @memberof AnswererLineProfile
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AnswererLineProfile
     */
    pictureUrl?: string;
}

/**
 * Check if a given object implements the AnswererLineProfile interface.
 */
export function instanceOfAnswererLineProfile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "displayName" in value;

    return isInstance;
}

export function AnswererLineProfileFromJSON(json: any): AnswererLineProfile {
    return AnswererLineProfileFromJSONTyped(json, false);
}

export function AnswererLineProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswererLineProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': json['displayName'],
        'pictureUrl': !exists(json, 'pictureUrl') ? undefined : json['pictureUrl'],
    };
}

export function AnswererLineProfileToJSON(value?: AnswererLineProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'pictureUrl': value.pictureUrl,
    };
}

